import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Plus,
    Users,
    Briefcase,
    X,
    Search,
    Info,
    Loader,
    MapPin,
    UserCheck,
} from "lucide-react";
import Swal from "sweetalert2";
import { getDirectReportsRequest } from "../../../../redux/actions/userActions";
import { createMissionRequestForCollabRequest } from "../../../../redux/actions/missionRequestActions";
import { fetchOrdreMissionActifsRequest } from "../../../../redux/actions/ordreMissionActions";
import "../MesrequetesStyles/MesOrdres.css";

const DemandeMissionManager = () => {
    const dispatch = useDispatch();

    // Redux state
    const user = useSelector((state) => state.auth.user);
    const { directReports, directReportsLoading } = useSelector((state) => state.user || {
        directReports: [],
        directReportsLoading: false,
    });
    const { ordresMissionActifs, loading: missionsLoading } = useSelector(
        (state) => state.ordreMission || { ordresMissionActifs: [], loading: false }
    );

    const [showModal, setShowModal] = useState(false);
    const [selectedMission, setSelectedMission] = useState(null);
    const [searchCollaborateur, setSearchCollaborateur] = useState("");
    const [selectedCollaborateurs, setSelectedCollaborateurs] = useState([]);
    const [formData, setFormData] = useState({
        motif: "",
        urgence: false,
    });

    // Au début du composant, après la ligne 23
    useEffect(() => {
        console.group('🔵 MOUNT DemandeMissionManager');
        console.log('👤 User:', user);
        console.log('🆔 User ID:', user?.id);
        console.groupEnd();

        if (user?.id) {
            console.log('✅ Dispatch getDirectReportsRequest avec managerId:', user.id);
            dispatch(getDirectReportsRequest(user.id));
        } else {
            console.error('❌ user.id est undefined, impossible de charger les collaborateurs');
        }

        dispatch(fetchOrdreMissionActifsRequest());
    }, [dispatch, user?.id]);
    // Charger les données au montage
    useEffect(() => {
        if (user?.id) {
            dispatch(getDirectReportsRequest(user.id));
        }
        dispatch(fetchOrdreMissionActifsRequest());
    }, [dispatch, user?.id]);

    const getCouleurByWorkflow = (workflow) => {
        const colors = {
            manager: "#3b82f6",
            admin: "#8b5cf6",
            both: "#10b981",
        };
        return colors[workflow] || "#6b7280";
    };

    // Missions disponibles
    const missionsDisponibles = useMemo(() => {
        if (!ordresMissionActifs || ordresMissionActifs.length === 0) return [];

        return ordresMissionActifs.map((om) => ({
            id: om.id,
            code: om.code,
            libelle: om.libelle,
            description: om.description,
            dateDebut: om.dateDebut,
            dateFin: om.dateFin,
            lieu: om.lieu,
            centreCout: om.centreCout,
            workflow: om.workflow,
            couleur: getCouleurByWorkflow(om.workflow),
        }));
    }, [ordresMissionActifs]);

    // Collaborateurs filtrés
    const collaborateursFiltres = useMemo(() => {
        if (!searchCollaborateur.trim()) return directReports;

        const term = searchCollaborateur.toLowerCase();
        return directReports.filter(
            (c) =>
                c.firstName?.toLowerCase().includes(term) ||
                c.lastName?.toLowerCase().includes(term) ||
                c.employeeCode?.toLowerCase().includes(term) ||
                c.email?.toLowerCase().includes(term)
        );
    }, [directReports, searchCollaborateur]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const d = new Date(dateStr);
        return d.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const getWorkflowLabel = (workflow) => {
        const labels = {
            manager: "Validation Manager",
            admin: "Validation RH",
            both: "Manager + RH",
        };
        return labels[workflow] || workflow;
    };

    const resetForm = () => {
        setFormData({
            motif: "",
            urgence: false,
        });
        setSelectedCollaborateurs([]);
        setSearchCollaborateur("");
    };

    const openModal = (mission) => {
        setSelectedMission(mission);
        setShowModal(true);
    };

    const toggleCollaborateur = (collabId) => {
        setSelectedCollaborateurs((prev) =>
            prev.includes(collabId)
                ? prev.filter((id) => id !== collabId)
                : [...prev, collabId]
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedMission) {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                text: "Veuillez sélectionner une mission",
                confirmButtonColor: "#204385",
            });
            return;
        }

        if (selectedCollaborateurs.length === 0) {
            Swal.fire({
                icon: "error",
                title: "Erreur",
                text: "Veuillez sélectionner au moins un collaborateur",
                confirmButtonColor: "#204385",
            });
            return;
        }

        const payload = {
            ordreMissionId: selectedMission.id,
            collaborateurIds: selectedCollaborateurs,
            motif: formData.motif || null,
            urgent: formData.urgence,
        };

        dispatch(createMissionRequestForCollabRequest(payload));
        setShowModal(false);
        resetForm();
        setSelectedMission(null);
    };

    const isLoading = directReportsLoading || missionsLoading;

    if (isLoading && directReports.length === 0 && missionsDisponibles.length === 0) {
        return (
            <div className="maPage">
                <div className="maWrap" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                    <Loader size={32} className="spin" />
                </div>
            </div>
        );
    }

    return (
        <div className="maPage">
            <div className="maWrap">
                {/* Header */}
                <div className="maHeader">
                    <h1>Demandes de mission pour mes collaborateurs</h1>
                    <p>Créez des demandes de mission pour vos équipes</p>
                </div>

                {/* Stats */}
                {/*<div className="maStats">*/}
                {/*    <div className="maStatCard">*/}
                {/*        <div className="maStatLeft">*/}
                {/*            <div className="maStatIcon maStatIcon--info">*/}
                {/*                <Users size={22} />*/}
                {/*            </div>*/}
                {/*            <div>*/}
                {/*                <div className="maStatLabel">Collaborateurs</div>*/}
                {/*                <div className="maStatValue maStatValue--pri">*/}
                {/*                    {directReports.length}*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className="maStatCard">*/}
                {/*        <div className="maStatLeft">*/}
                {/*            <div className="maStatIcon maStatIcon--ok">*/}
                {/*                <Briefcase size={22} />*/}
                {/*            </div>*/}
                {/*            <div>*/}
                {/*                <div className="maStatLabel">Missions disponibles</div>*/}
                {/*                <div className="maStatValue maStatValue--pri">*/}
                {/*                    {missionsDisponibles.length}*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Card missions */}
                <div className="maCard">
                    <div className="maSectionHead">
                        <div>
                            <div className="maSectionTitle">Missions disponibles</div>
                            <div className="maSectionSub">
                                Sélectionnez une mission pour créer une demande pour vos collaborateurs
                            </div>
                        </div>
                    </div>

                    {missionsLoading ? (
                        <div style={{ display: "flex", justifyContent: "center", padding: "40px" }}>
                            <Loader size={32} className="spin" />
                        </div>
                    ) : missionsDisponibles.length === 0 ? (
                        <div className="maEmpty">
                            <Briefcase size={38} />
                            <p>Aucune mission disponible pour le moment</p>
                        </div>
                    ) : (
                        <div className="maGrid2">
                            {missionsDisponibles.map((mission) => (
                                <div
                                    key={mission.id}
                                    className="maTypeCard is-eligible"
                                    style={{ borderColor: mission.couleur }}
                                    onClick={() => openModal(mission)}
                                    role="button"
                                    tabIndex={0}
                                >
                                    <div className="maTypeTop">
                                        <div className="maTypeLeft">
                                            <div
                                                className="maTypeIcon"
                                                style={{
                                                    backgroundColor: `${mission.couleur}20`,
                                                    color: mission.couleur,
                                                }}
                                            >
                                                <Briefcase size={18} />
                                            </div>
                                            <div>
                                                <div className="maTypeName">{mission.libelle}</div>
                                                <div
                                                    className="maPill"
                                                    style={{
                                                        backgroundColor: `${mission.couleur}20`,
                                                        color: mission.couleur,
                                                    }}
                                                >
                                                    {mission.code}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="maTypeDesc">
                                        {mission.description || "Aucune description"}
                                    </div>

                                    <div className="maTypeGrid">
                                        <div>
                                            <div className="maMuted">Date début</div>
                                            <div className="maStrong" style={{ color: mission.couleur }}>
                                                {formatDate(mission.dateDebut)}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="maMuted">Date fin</div>
                                            <div className="maStrong">{formatDate(mission.dateFin)}</div>
                                        </div>
                                        {mission.lieu && (
                                            <div>
                                                <div className="maMuted">Lieu</div>
                                                <div className="maStrong">
                                                    <MapPin size={14} style={{ display: "inline", marginRight: 4 }} />
                                                    {mission.lieu}
                                                </div>
                                            </div>
                                        )}
                                        <div>
                                            <div className="maMuted">Validation</div>
                                            <div className="maStrong">{getWorkflowLabel(mission.workflow)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/*<div className="maInfoBox">*/}
                    {/*    <Info size={18} />*/}
                    {/*    <div>*/}
                    {/*        <div className="maInfoTitle">Informations importantes</div>*/}
                    {/*        <ul className="maInfoList">*/}
                    {/*            <li>Vous pouvez sélectionner plusieurs collaborateurs pour une même mission</li>*/}
                    {/*            <li>Les demandes suivront le workflow de validation configuré</li>*/}
                    {/*            <li>Vos collaborateurs seront notifiés de la demande créée</li>*/}
                    {/*        </ul>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>

            {/* MODAL - Créer demande */}
            {showModal && selectedMission && (
                <div className="maModal">
                    <div className="maModal__panel" style={{ maxWidth: "700px" }}>
                        <div className="maModal__header">
                            <div className="maModal__headLeft">
                                <div className="maModal__icon">
                                    <UserCheck size={18} />
                                </div>
                                <div>
                                    <div className="maModal__title">Créer une demande de mission</div>
                                    <div className="maModal__sub">{selectedMission.libelle}</div>
                                </div>
                            </div>

                            <button
                                className="maIconBtn"
                                onClick={() => {
                                    setShowModal(false);
                                    resetForm();
                                    setSelectedMission(null);
                                }}
                                aria-label="Fermer"
                            >
                                <X size={18} />
                            </button>
                        </div>

                        <div className="maModal__body">
                            <form onSubmit={handleSubmit}>
                                {/* Info mission */}
                                <div className="maInfoInline">
                                    <div className="maInlineGrid">
                                        <div>
                                            <div className="maMuted">Code</div>
                                            <div className="maStrong" style={{ color: selectedMission.couleur }}>
                                                {selectedMission.code}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="maMuted">Date début</div>
                                            <div className="maStrong">{formatDate(selectedMission.dateDebut)}</div>
                                        </div>
                                        <div>
                                            <div className="maMuted">Date fin</div>
                                            <div className="maStrong">{formatDate(selectedMission.dateFin)}</div>
                                        </div>
                                        {selectedMission.lieu && (
                                            <div>
                                                <div className="maMuted">Lieu</div>
                                                <div className="maStrong">
                                                    <MapPin size={14} style={{ display: "inline", marginRight: 4 }} />
                                                    {selectedMission.lieu}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Recherche collaborateurs */}
                                <div className="maField">
                                    <label>
                                        Sélectionner les collaborateurs *{" "}
                                        <span className="maHelp">
                                            ({selectedCollaborateurs.length} sélectionné{selectedCollaborateurs.length > 1 ? "s" : ""})
                                        </span>
                                    </label>
                                    <div style={{ position: "relative" }}>
                                        <Search
                                            size={18}
                                            style={{
                                                position: "absolute",
                                                left: 12,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                color: "#9ca3af",
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder="Rechercher un collaborateur..."
                                            value={searchCollaborateur}
                                            onChange={(e) => setSearchCollaborateur(e.target.value)}
                                            style={{ paddingLeft: 40 }}
                                        />
                                    </div>
                                </div>

                                {/* Liste collaborateurs */}
                                <div
                                    style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "8px",
                                        padding: "8px",
                                    }}
                                >
                                    {directReportsLoading ? (
                                        <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                                            <Loader size={24} className="spin" />
                                        </div>
                                    ) : collaborateursFiltres.length === 0 ? (
                                        <div className="maEmpty" style={{ padding: "20px" }}>
                                            <Users size={32} />
                                            <p>Aucun collaborateur trouvé</p>
                                        </div>
                                    ) : (
                                        collaborateursFiltres.map((collab) => (
                                            <label
                                                key={collab.id}
                                                className="maCollabRow"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "12px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    marginBottom: "4px",
                                                    backgroundColor: selectedCollaborateurs.includes(collab.id)
                                                        ? "#eff6ff"
                                                        : "#fff",
                                                    border: selectedCollaborateurs.includes(collab.id)
                                                        ? "1px solid #3b82f6"
                                                        : "1px solid #e5e7eb",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={selectedCollaborateurs.includes(collab.id)}
                                                    onChange={() => toggleCollaborateur(collab.id)}
                                                    style={{ marginRight: 12 }}
                                                />
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontWeight: 500, color: "#111827" }}>
                                                        {collab.firstName} {collab.lastName}
                                                    </div>
                                                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                                                        {collab.employeeCode} • {collab.email}
                                                    </div>
                                                    {collab.jobName && (
                                                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>
                                                            {collab.jobName}
                                                        </div>
                                                    )}
                                                </div>
                                            </label>
                                        ))
                                    )}
                                </div>

                                {/* Motif */}
                                <div className="maField">
                                    <label>Motif de la demande (optionnel)</label>
                                    <textarea
                                        rows={4}
                                        value={formData.motif}
                                        onChange={(e) => setFormData((p) => ({ ...p, motif: e.target.value }))}
                                        placeholder="Expliquez pourquoi vous créez cette demande pour vos collaborateurs..."
                                    />
                                </div>

                                {/* Urgence */}
                                <div className="maCheckRow">
                                    <label className="maCheck">
                                        <input
                                            type="checkbox"
                                            checked={formData.urgence}
                                            onChange={(e) => setFormData((p) => ({ ...p, urgence: e.target.checked }))}
                                        />
                                        <span>Marquer comme urgent</span>
                                    </label>
                                    <span className="maHelp">Les demandes urgentes sont traitées en priorité</span>
                                </div>

                                <div className="maModal__footer">
                                    <button
                                        type="button"
                                        className="maBtn maBtn--ghost"
                                        onClick={() => {
                                            setShowModal(false);
                                            resetForm();
                                            setSelectedMission(null);
                                        }}
                                    >
                                        Annuler
                                    </button>
                                    <button
                                        type="submit"
                                        className="maBtn maBtn--accent"
                                        disabled={isLoading || selectedCollaborateurs.length === 0}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Loader size={16} className="spin" />
                                                Envoi en cours...
                                            </>
                                        ) : (
                                            <>
                                                <Plus size={16} />
                                                Créer {selectedCollaborateurs.length} demande{selectedCollaborateurs.length > 1 ? "s" : ""}
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DemandeMissionManager;